import React, { useState, useEffect} from 'react';
import classes from './index.css';
import TransitionExpand from './TransitionExpand';
import WorkroleCert from './WorkroleCert';
import WorkroleComps from './WorkroleComps';
import _ from 'lodash'
export default function WorkroleDetails(props){
    const [lastExposedCompsValues, setLastExposedCompsValues] = useState(null);
    const [savedChildData, setSavedChildData] = useState({});
    const [certsExpanded, setCertsExpanded] = useState(false);
    const [compsExpanded, setCompsExpanded] = useState(false);
    const [certsShown, setCertsShown] = useState(props.allcerts);

    const getCompIdNumber = (dbid) =>{
        return props.competencies[dbid].idnumber;
    }
    const getCompExposed = (dbid)=> {
        var count=0;
        var foundcourses=[];
        var crslist= props.courses;
        Object.keys(crslist).forEach(crsid =>{
            var crs=crslist[crsid];
            //directly copied this from vue.. I feel like it always returns false
            if(crs.competencies.find(el => el == dbid) || false){
                count++
                foundcourses.push({id:crsid, name:crs.course.shortname})
            }
        });
        var ret = {count:count,names:foundcourses};
        //this.lastExposedCompValues = ret
        return ret;
    }

    
    const saveChildData = (stuff, key) =>{
        var scd = _.cloneDeep(savedChildData);
        scd[key] = stuff;
        if(!_.isEqual(scd, savedChildData)) setSavedChildData(scd);
    }
    
    /*
    const toggleView = (el) =>{
        this[el] = !this[el]
    }  
    */

    const toggleCertsShown = (certid) =>{
        var cs = _.cloneDeep(certsShown);
        cs[certid] = !cs[certid];
        // console.log({certid: certid, cs:cs, certsShown: certsShown})
        if(!_.isEqual(cs, certsShown)) setCertsShown(cs);
    }
    
    useEffect(() => {
        //if exists (not undefined or null)
        if(props.parentSaved){
            Object.keys(props.parentSaved).forEach(key => {
                //need to review what this means and translate to react
                //this[key]=this.parentSaved[key]
            })
        }   
    })

    var lvl3CertBtnClass = certsExpanded ? classes.btnPressed : classes.btnNotPressed
    
    var lvl3CompBtnClass = compsExpanded ? classes.btnPressed : classes.btnNotPressed

    var isFullFlex = compsExpanded  && classes.fullFlex;
    return(
        <div className={classes.workroleDetails}>
            <h4>{props.wr.name}</h4>
            <div
                className={classes.buttonRow}
            >
                {props.certs && Object.keys(props.certs).length ? (
                    <div className={classes.btnLvl3 +  ' ' + lvl3CertBtnClass} onClick={() => {setCertsExpanded(!certsExpanded)}}>
                        <h4>
                            {props.wr.shortname} Related Certifications
                        </h4>
                    </div>
                ) : <></>}
                {props.competencies && Object.keys(props.competencies).length ? (
                    <div className={classes.btnLvl3 + ' ' + lvl3CompBtnClass} onClick={() => {setCompsExpanded(!compsExpanded)}}>
                        <h4>
                            {props.wr.shortname} Competencies
                        </h4>
                    </div>
                ) : <></>}

            </div>
            <TransitionExpand duration={500} height={certsExpanded ? 'auto' : 0}>
                {certsExpanded && (
                    <>
                    <div className={classes.fullFlex}>
                        <h5>{props.wr.shortcode} Related Certifications</h5>
                    </div>
                    <div className={classes.buttonRow}>
                        {Object.keys(props.certs).map( (id, kee) => {
                            var cert = props.certs[id];
                            var isPressed = certsShown[id] ? classes.btnPressed : classes.btnNotPressed
                            return(
                                <div
                                    key={kee}
                                    className={classes.btnLvl4 + ' ' + isPressed}
                                    onClick={() => toggleCertsShown(id)}>
                                        <h5>{cert.name}</h5>
                                </div>
                            )
                        })}
                    </div>
                        {Object.keys(props.certs).map( (id, kee) => {
                            var cert = props.certs[id];
                            if(certsShown[id]){
                                return(
                                    
                                    <TransitionExpand
                                        key={kee}
                                        duration={500} height={certsShown[id] ? 'auto' : 0}
                                    >
                                        <WorkroleCert
                                            className={classes.wrCertDetails + ' ' + classes.fullFlex}
                                            cert={props.allcerts[id]}
                                            parentSaved={savedChildData[id]}
                                            //@save-please="saveChildData($event, certid)"
                                        />
                                    </TransitionExpand>
                                )
                            }
                         })}
                    </>
                )}
            </TransitionExpand>
            {props.comps && Object.keys(props.comps).length &&
                (<div className={classes.wrComps + ' ' + isFullFlex}>
                    <TransitionExpand duration={500} height={compsExpanded ? 'auto' : 0}>
                        {compsExpanded && (
                            <WorkroleComps
                                comps={props.comps}
                                key={compsExpanded}
                                courses={props.courses}
                                competencies={props.competencies}
                                wr={props.wr}
                            />
                        )}
                    </TransitionExpand>
                </div>)
            }
        </div>
    )
   /*
    return(
        <div class='workrole-details'>
            <h4>{props.wr.name}</h4>
            <div
                className={classes.buttonRow}
            >
                <div
                    v-if="certs && Object.keys(certs).length"
                    class='btn-lvl3'
                    :class="{'btn-not-pressed':!certsExpanded, 'btn-pressed': certsExpanded}"
                    @click="toggleView('certsExpanded')"
                >
                    <h4>
                        {{wr.shortcode}} Related Certifications 
                    </h4>
                </div>
                <div
                    class='btn-lvl3'
                    v-if="comps && Object.keys(comps).length"
                    :class="{'btn-not-pressed':!compsExpanded, 'btn-pressed': compsExpanded}"
                    @click="toggleView('compsExpanded')"
                >
                    <h4>
                        {{wr.shortcode}} Competencies
                    </h4>
                </div>
            </div>
            <TransitionExpand name='slide'>
            <div
                v-if="certsExpanded"
                class='full-flex'
            >
                <h5>
                    {{wr.shortcode}} Related Certifications 
                </h5>
                <div class="button-row">
                    <div
                        v-for="(cert, certid) in certs"
                        :key="certid"
                        class="btn-lvl4"
                        :class="{'btn-not-pressed':!certsShown[certid], 'btn-pressed': certsShown[certid]}"
                        @click="toggleCertsShown(certid)"
                    >
                    <h5>{{cert.name}}</h5>
                    </div>
                </div>
                <TransitionExpand
                    v-for="(cert, certid) in certs"
                    :key="certid"
                >
                <WorkroleCert
                    class="wr-cert-details full-flex"
                    v-if="certsShown[certid]"
                    :cert="allcerts[certid]"
                    :parentSaved="savedChildData[certid]"
                    @save-please="saveChildData($event, certid)"
                />
                </TransitionExpand>
            </div>
            </TransitionExpand>
            <div class="wr-comps"
                v-if="comps && Object.keys(comps).length"
                :class="{'full-flex': compsExpanded}"
            >
                <TransitionExpand name="slide">
                    <WorkroleComps 
                        v-if="compsExpanded"
                        :comps="comps"
                        :key="compsExpanded"
                        :courses="courses"
                        :competencies="competencies"
                        :wr="wr"
                    />
                </TransitionExpand>
            </div>
        </div>
    )
    */
}